module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "reservation-modal payment dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Manage Locations")]), _vm._v(" "), _c('h3', [_vm._v("Create the list of locations where you usually transport clients.")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-lighter",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "d-flex h-80"
  }, [_c('div', {
    staticClass: "col-sm-4 d-flex flex-column justify-content-between border-right-medium"
  }, [_c('div', {
    staticClass: "w-100 bg-lighter"
  }, [_c('button', {
    staticClass: "btn cancel widest bg-color-1 lightest w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNewLocation
    }
  }, [_c('i', {
    staticClass: "ico ico-add"
  }), _vm._v("New location")])]), _vm._v(" "), (_vm.locationsList.length == 0) ? _c('div', {
    staticClass: "text-center dark my-3"
  }, [_vm._v("No locations to list")]) : _c('div', {
    staticClass: "row flex-column h-100"
  }, [_c('ul', {
    staticClass: "scrollMe w-100"
  }, _vm._l((_vm.locationsList), function(location) {
    return _c('li', {
      staticClass: "locationRow pointer d-flex justify-content-between px-2 py-1",
      class: {
        'font-weight-600 underlined': location.selected
      },
      on: {
        "click": function($event) {
          return _vm.selectLocationToEdit(location)
        }
      }
    }, [_c('span', [_vm._v("\n                                " + _vm._s(location.name) + "\n                                ")]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "ico ico-delete fs-normal",
      on: {
        "click": function($event) {
          return _vm.askeToDeleteLocation(location)
        }
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 p-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 mb-2"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLocation.name),
      expression: "selectedLocation.name"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedLocation.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedLocation, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mb-2"
  }, [_c('label', {
    staticClass: "w-100"
  }, [_vm._v("GPS Coordinates")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "w-100"
  }, [_vm._v("Lat")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLocation.latitude),
      expression: "selectedLocation.latitude"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedLocation.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedLocation, "latitude", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "w-100"
  }, [_vm._v("Long")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLocation.longitude),
      expression: "selectedLocation.longitude"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedLocation.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedLocation, "longitude", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mb-2"
  }, [_c('label', [_vm._v("Notes")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLocation.notes),
      expression: "selectedLocation.notes"
    }],
    domProps: {
      "value": (_vm.selectedLocation.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedLocation, "notes", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex mt-4 justify-content-end"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.saveLocation
    }
  }, [_vm._v(_vm._s(_vm.isSaving ? 'Saving' : 'Save Location'))])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel widest",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok widest",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Ok")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7124f9ce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7124f9ce"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/TransportManageLocations.vue
// module id = 2153
// module chunks = 0